import styled from 'styled-components';

import Button from 'components/shared/Button';
import StandardModal, { Actions, ColorThemeName, PatientName } from 'components/shared/StandardModal';
import { useTourMutation } from 'hooks/useWorkflowTours';
import { TourOptions } from 'models/Tour';
import Workflow from 'models/Workflow';
import { deleteTour } from 'services/api/tours';
import { BodySmall } from 'styles/typography';

type Props = {
  workflow: Workflow;
  tour: TourOptions;
  onClose: () => void;
};

export default function DeleteTourModal({ workflow, tour, onClose }: Props) {
  const { mutate: remove, isPending } = useTourMutation({
    workflowId: workflow.id,
    mutationFn: deleteTour,
    successText: 'Tour log deleted',
    onSuccess: onClose,
  });

  return (
    <StandardModal colorTheme={ColorThemeName.PrimaryRed} onCancel={onClose} title='Delete Tour Log?'>
      <Content data-testid='delete-tour-modal'>
        <PatientName>Patient: {workflow.patientName}</PatientName>
        <BodySmall>
          <Emphasis>Are you sure you wish to delete this tour log?</Emphasis> Once deleted, it will no longer be shown
          on the referral. Tour logs can always be re-added at a later time.
        </BodySmall>
      </Content>
      <Actions>
        <Button variant='ghost' onClick={onClose} data-testid='delete-tour-cancel'>
          Cancel
        </Button>
        <Button
          variant='danger'
          onClick={() => remove({ workflowId: workflow.id, id: tour.id })}
          loading={isPending}
          data-testid='delete-tour-confirm'>
          Delete Tour Log
        </Button>
      </Actions>
    </StandardModal>
  );
}

const Content = styled.div`
  margin: 8px 0 32px;
`;

const Emphasis = styled.span`
  font-weight: 500;
`;
